import { BCMSRecord, BCMSRecordProperty } from "@bcm-dev/bcms-vite";
import { PositivePayCheckFile } from "model";
/**
* @class PositivePayCheckFileRow
* @classdesc Class definition for record type from model
* @param {OBJECT} record - record from model to init class
* @property {STRING} _id - The account of the check.
* @extends BCMSRecord
* @example const record = model.positivePayCheckFileRos[0];
* const profile = new PositivePayCheckFileRow(record);
*/
export default class PositivePayCheckFileRow extends BCMSRecord {
    _id
    _positivePayCheckFile
    _checkDate
    _checkNumber
    _business
    _accountNumber
    _accountNickname
    _payee
    _amount
    _status

    constructor(record) {     
      super(record) 
    }
  }
  PositivePayCheckFileRow.define({
    "recordType": "positivePayCheckFileRows",
    "recordIDProp":"id",
    "className" : "PositivePayCheckFileRow",
    "recordProperties":[
    /** 
     * @name id
     * @instance
     * @property get {STRING} - gets the id
     * @property set {STRING} - sets the id
     * @memberof PositivePayCheck
     */
    BCMSRecordProperty.mapToString("id","_id"),

    /** 
     * @name positivePayCheckFile
     * @instance
     * @property get {STRING} - gets the positivePayCheckFile 
     * @property set {STRING} - sets the positivePayCheckFile 
     * @memberof PositivePayCheckFileRow
     */
    BCMSRecordProperty.mapToClass("positivePayCheckFile","_positivePayCheckFile", () => PositivePayCheckFile),

    /** 
     * @name checkDate
     * @instance
     * @property get {STRING} - gets the checkDate 
     * @property set {STRING} - sets the checkDate 
     * @memberof PositivePayCheck
     */
    BCMSRecordProperty.mapToString("checkDate","_checkDate"),

    /** 
     * @name checkNumber
     * @instance
     * @property get {STRING} - gets the checkNumber 
     * @property set {STRING} - sets the checkNumber 
     * @memberof PositivePayCheck
     */
    BCMSRecordProperty.mapToString("checkNumber","_checkNumber"),

    /** 
     * @name business
     * @instance
     * @property get {STRING} - gets the business 
     * @property set {STRING} - sets the business 
     * @memberof PositivePayCheck
     */
    BCMSRecordProperty.mapToString("business","_business"),

    /** 
     * @name accountNumber
     * @instance
     * @property get {STRING} - gets the accountNumber 
     * @property set {STRING} - sets the accountNumber 
     * @memberof PositivePayCheck
     */
    BCMSRecordProperty.mapToString("accountNumber","_accountNumber"),

    /** 
     * @name accountNickname
     * @instance
     * @property get {STRING} - gets the accountNickname 
     * @property set {STRING} - sets the accountNickname 
     * @memberof PositivePayCheck
     */
    BCMSRecordProperty.mapToString("accountNickname","_accountNickname"),

    /** 
     * @name payee
     * @instance
     * @property get {STRING} - gets the payee 
     * @property set {STRING} - sets the payee 
     * @memberof PositivePayCheck
     */
    BCMSRecordProperty.mapToString("payee","_payee"),

    /** 
     * @name amount
     * @instance
     * @property get {STRING} - gets the amount 
     * @property set {STRING} - sets the amount 
     * @memberof PositivePayCheck
     */
    BCMSRecordProperty.mapToString("amount","_amount"),

    /** 
     * @name status
     * @instance
     * @property get {STRING} - gets the status 
     * @property set {STRING} - sets the status 
     * @memberof PositivePayCheck
     */
    BCMSRecordProperty.mapToString("status","_status"),

    ]  
})




